module.exports = __webpack_public_path__ + "img/65aa9f5.png";